"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ControlRendererContext_1 = __importDefault(require("../../../ControlRendererContext"));
const LoadingPlaceholder_1 = __importDefault(require("../LoadingPlaceholder"));
const useControlEvents_1 = __importDefault(require("../../hooks/useControlEvents"));
const useOnLoad_1 = __importDefault(require("../../hooks/useOnLoad"));
const WebViewRenderer = ({ control, style, }) => {
    const { Render } = (0, react_1.useContext)(ControlRendererContext_1.default);
    const events = (0, useControlEvents_1.default)(control);
    (0, useOnLoad_1.default)(control, events);
    const webviewStyle = (0, react_1.useMemo)(() => (Object.assign(Object.assign({}, style), { flex: 0, minWidth: style.width, minHeight: style.height })), [style]);
    const webConfig = (0, react_1.useMemo)(() => {
        if (!control.href) {
            return {
                href: 'https://io',
            };
        }
        if (/\.pdf$/.test(control.href) || control.forcePdf) {
            return {
                href: `https://drive.google.com/viewerng/viewer?embedded=true&url=${control.href}`,
            };
        }
        return {
            href: control.href,
        };
    }, [control.href, control.forcePdf]);
    return (react_1.default.createElement(LoadingPlaceholder_1.default, { control: control, style: webviewStyle },
        react_1.default.createElement(Render.WebView, { webConfig: webConfig, style: webviewStyle, injectedJavaScript: control.injectedJavaScript, onNavigationStateChange: events.onNavigationStateChange, onMessage: events.onMessage })));
};
exports.default = WebViewRenderer;
